import React from 'react'
// import PropTypes from 'prop-types'
// import styled from 'styled-components'

const ForgotPassPage = () => {
	return <p>Forgot pass page</p>
}
ForgotPassPage.propTypes = {}
export default ForgotPassPage
